export default {
    fund: [{
            "title": "对股权投资基金估值时，项目组合中某互联网公司收入波动较大，尚未产生盈利，公司刚完成B轮融资。最适合对该公司估值的方法是（　　）。",
            "question": "A. 近期交易价格法\nB. 乘数法\nC. 收入法\nD. 有效市场价格法",
            "answer": "A",
            "explain": "近期交易价格法适用于相关投资项目发生交易之后一段有限的时间内。如果该投资项目近期接受了新的投资，该近期投资价格为估值提供了依据。"
        },
        {
            "title": "下列关于基金合同表述错误的是（　　）。",
            "question": "A. 基金管理人应在签订合同前已向投资者揭示了相关风险且已经了解基金投资者风险偏好、风险认知和承受能力\nB. 基金合同条款应当包括信息披露制度\nC. 基金合同必须与中国证券投资基金业协会合同指引完全一致\nD. 基金合同中应以加粗字体列明私募基金管理人保证在募集资金前已在中国证券投资基金业协会登记为私募基金管理人，并列明管理人登记编码",
            "answer": "C",
            "explain": "基金合同条款应当包括基本情况、投资事项、利润分配及亏损分担、税务承担、费用和支出、财务会计制度、信息披露制度等。"
        },
        {
            "title": "李某于2010年初向A基金投资了500万元，基金合同约定基金管理费每年为总投资额的1%，2012年末和2013年末李某分别收到项目退回款100万元和200万元，另外，2012年末和2013年末李某持有的基金份额的估值分别是800万元和600万元，2013年末李某投资A基金的总收益倍数是（　　）。",
            "question": "A. 1.8\nB. 1.4\nC. 0.6\nD. 3.4",
            "answer": "A",
            "explain": "总收益倍数的计算公式为：TVPI=（投资者的历年分配总和+资产净值）/投资者的历年缴款总和。"
        },
        {
            "title": "关于合伙型股权投资基金，表述正确的是（　　）。",
            "question": "A. 所有合伙人对基金债务以出资额为限承担责任\nB. 所有合伙人可以按出资份额行使基金投资决策表决权\nC. 只有在实现基金整体盈利时才可以进行收益分配\nD. 合伙型基金无须缴纳企业所得税",
            "answer": "D",
            "explain": "普通合伙人对基金（合伙企业）债务承担无限连带责任，有限合伙人以其认缴的出资额为限对基金（合伙企业）债务承担责任。"
        },
        {
            "title": "关于创业投资估值法，正确的操作步骤是（　　）。",
            "question": "A. 预估对于项目公司的投资额度、计算目标回报倍数、测算要求持股比例、预计退出的时间长度\nB. 预估退出时项目公司的股权价值、计算退出的时间长度、测算可能的股权稀释情况、预计目标回报倍数\nC. 预估退出时项目公司的股权价值、计算当前股权价值、测算要求持股比例、预计可能的股权稀释情况\nD. 预估项目公司的融资节点、计算项目投资的资金成本、测算项目公司的股权价值、预计退出的时间长度",
            "answer": "C",
            "explain": "创业投资估值法的步骤包括预估退出时项目公司的股权价值、计算当前股权价值、测算要求持股比例、预计可能的股权稀释情况。"
        },
        {
            "title": "股权投资基金募集流程涉及的主要资料包括（　　）。",
            "questions": "I. 私募备忘录<br>II. 募集推介资料<br>III. （反向）尽职调查资料<br>IV. 基金条款书",
            "question": "A. II、III、IV\nB. I、III、IV\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查募集所需主要材料。"
        }, {
            "title": "股权投资基金对处于创业早期的某生物医药企业进行业务尽职调查，业务尽职调查阶段重点关注的内容是（　　）。",
            "questions": "I. 管理团队履历<br>II. 公司薪酬体系与激励机制<br>III. 核心产品研发进展与预期<br>IV. 营销策略与业务发展目标",
            "question": "A. I、II、III\nB. II、III、IV\nC. II、III\nD. I、II、III、IV",
            "answer": "A",
            "explain": "股权投资基金对创业企业的考察重点为管理团队和产品服务部分。"
        },
        {
            "title": "关于合伙型股权投资基金清算退出的资产分配顺序，以下表述正确的是（　　）。",
            "question": "A. 所欠税款、职工工资、清算费用、外部债务、合伙人分配\nB. 清算费用、所欠税款、职工工资、外部债务、合伙人分配\nC. 清算费用、职工工资、所欠税款、外部债务、合伙人分配\nD. 职工工资、所欠税款、清算费用、外部债务、合伙人分配",
            "answer": "C",
            "explain": "本题考查合伙型股权投资基金清算退出的资产分配顺序。"
        },
        {
            "title": "某合伙型股权投资基金已经成立1年，合伙人甲拟全部退伙，合伙人乙拟追加投资，投资人丙拟入伙，以下表述正确的是（　　）。",
            "questions": "I. 如果甲退伙，则甲减少出资、退出合伙企业<br>II. 乙需按照规定比例享受合伙企业的权益<br>III. 丙需要满足合格投资者要求<br>IV. 如果合伙企业没有其他约定，丙的入伙需要经过2/3以上合伙人的同意<br>V、丙以其认缴的出资额为限对入伙的合伙企业的债务承担责任",
            "question": "A. II、III、IV\nB. I、II、III、IV\nC. I、II、IV\nD. I、II、III、V",
            "answer": "D",
            "explain": "本题考查合伙型股权投资基金的入伙/增加出资、退伙/减少出资。"
        },
        {
            "title": "某股权投资基金对目标公司A进行法律尽职调查，发现A公司近期存在以下诉讼和仲裁事项。关于法律尽职调查应关注的主要内容，以下表述正确的是（　　）。",
            "question": "A. A公司就与某公司的业务往来争议进行仲裁并已获得当地仲裁委员会的支持，应主要关注该仲裁机构的委员构成\nB. A公司在与某公司的诉讼终审中胜诉并判决某公司应对A公司进行赔款，应主要关注是否获得了法院出具的终审判决书\nC. A公司已结案的败诉案件中，应主要关注当事各方在该案件过程中是否存在疑点等可能影响败诉的因素\nD. A公司的未决仲裁中，应主要关注起因，主要过程及双方在诉求上存在的差异等因素",
            "answer": "D",
            "explain": "法律尽职调查对于诉讼及仲裁，重点关注：(1)对未决诉讼与仲裁，要详细核查起因、当事各方、主要过程及争议点。(2)对已决诉讼与仲裁，律师应关注裁决的履行情况，如应支付的款项是否已经完成支付并取得相应凭证，是否存在后续的法律程序及可能的法律风险。"
        },
        {
            "title": "对信息披露义务人违反《私募投资基金信息披露管理办法》的，投资者可以向中国证券投资基金业协会投诉或举报，中国证券投资基金业协会可以要求其限期改正，逾期未改正的，中国证券投资基金业协会可视情节轻重，对信息披露义务人及主要负责人采取（　　）纪律处分。",
            "questions": "I. 谈话提醒<br>II. 书面警示<br>III. 要求参加强制培训<br>IV. 行业内谴责",
            "question": "A. II、III、IV\nB. I、II、III、IV\nC. I、III、IV\nD. I、II、III",
            "answer": "B",
            "explain": "信息披露义务人违反《私募投资基金信息披露管理办法》的，投资者可以向基金业协会投诉或举报，基金业协会可以要求其限期改正，逾期未改正的，基金业协会可视情节轻重，对信息披露义务人及主要负责人采取相应纪律处分。"
        },
        {
            "title": "王某2008年初向A基金投资了200万元，基金合同约定基金管理费为每年2%。2010年末，王某分别收到项目退出回款30万元，某持有的基金份额的估值为300万元。2012年末王某投资A基金的已分配收益倍数（DPI）为（　　）。",
            "question": "A. 2.0\nB. 0.44\nC. 1.96\nD. 0.5",
            "answer": "D",
            "explain": "已分配收益倍数=投资者分配金额总和/投资者缴款金额总和，其中，投资者分配金额总和=30+70=100（万元）;投资者缴款总和=200万元，代入公式已分配收益倍数DPI=100/200=0.5。"
        }, {
            "title": "国家对创业投资企业和天使投资个人在税收上给予特别的支持，下列关于天使投资人相关税收事项的表述，正确的是（　　）。",
            "question": "A. 甲投资多个初创科技型企业时，其中一家已办理注销清算，对其投资者的70%未被扣除的部分，在其3年内可以抵扣甲转让其他初创科取得的纳税所得额\nB. 甲按照投资额的70%抵扣转让某机例科技型企业股权取得的应纳税所得额。如果当年不足抵扣的，不能在以后的纳税年度结转\nC. 甲投资了一家初创科技型企业，同时也是这家初创科技企业的发起人，仍可享受相关税收政策\nD. 甲与科技企业签订对赌条款，以可转债的方式投资，约定业绩额不达标则不转为股权，该笔投资仍可享受相关的税收政策",
            "answer": "A",
            "explain": "本题考查运用税收政策，鼓励创业投资基金增加早期投资。"
        },
        {
            "title": "基金管理人为保证基金财产安全，会聘请基金资产保管机构对基金资产承担保管责任，基金资产保管机构是（　　）。",
            "question": "A. 基金投资者的代理人\nB. 基金投资者和基金管理人的共同财产监管人\nC. 基金管理人的代理人\nD. 基金投资者和基金管理人的共同代理人",
            "answer": "C",
            "explain": "本题考查基金资产保管与基金托管的不同。"
        },
        {
            "title": "某股权投资基金拟投资一家制药企业，预计4年退出时的股权价值是40亿元，目标回报倍数是10，则该企业当前的估值是（　　）。",
            "question": "A. 3\nB. 4\nC. 5\nD. 6",
            "answer": "B",
            "explain": "本题考查创业投资估值法的计算。"
        },
        {
            "title": "基金风险揭示中属于“流动性风险”的是（　　）。",
            "question": "A. 在某些情况下，被投资公司的重组计划及经营业务改进存在高度不确定性，无法确保本基金将能成功确定及执行有关重组计划及改进措施\nB. 本基金存续期内，投资者可能面临资金不能退出的风险\nC. 基金管理人不保证基金财产不受损失，也不保证一定盈利以及最低收益\nD. 基金管理人依据基金合同约定管理和运用基金财产所产生的风险，由基金全体投资者承担",
            "answer": "B",
            "explain": "本题考查基金的流动性风险。"
        },
        {
            "title": "关于股权投资基金募集，以下表述错误的是（　　）。",
            "question": "A. 募集过程中必须对投资者的风险识别能力和风险承担能力进行评估\nB. 在我国，股权投资基金可以选择公开募集或非公开募集两种方式\nC. 基金管理人委托第三方代销机构募集时，需确保该代销机构获得中国证监会基金销售\nD. 管理人可自行拟定基金募集推荐材料并寻找投资者",
            "answer": "B",
            "explain": "本题考查股权投资基金募集。"
        },
        {
            "title": "股权投资基金在与目标公司签订投资协议时，通常会被写入优先认购权条款的内容为（　　）。",
            "questions": "I. 目标企业发行新股时，作为老股东的股权投资人可以按照比例优先于新进投资人进行认购<br>II. 目标企业发行可转换债券时，作为老股东的股权投资人可以按照比例优先与新进投资人进行认购<br>III. 目标企业的其他股东对外出售股权，是作为老股东的股权投资人在同等级条件下，有优先认购权<br>IV. 目标企业在与股权投资基金进行谈判过程中，不得再与其他投资机构接触",
            "question": "A. I、II\nB. III\nC. I、II、III\nD. I、II、III、IV",
            "answer": "A",
            "explain": "本题考查优先认购权条款。"
        }, {
            "title": "既能满足对基金管理人形成激励，同时也符合基金管理人和基金投资者双方的一致性利益，符合要求的做法为（　　）。",
            "question": "A. 先返还投资本金，其次向投资者支付约定的优先收益，最后双方按约定比例分配剩余收益\nB. 先向管理人分配超额收益，其次向投资者返还投资本金并支付约定的优先收益\nC. 先支付代扣代缴的税费，其次双方按约定比例分配剩余收益，最后向投资者返还投资本金\nD. 先支付代扣代缴的税费，其次向投资者返还投资本金，最后双方按约定比例分配剩余收益",
            "answer": "A",
            "explain": "本题考查基金收益分配。为建立对管理人的激励机制，股权投资基金管理人通常参与基金收益的分配，因其管理可以获得相当于基金利润一定比例的业绩报酬。基金与基金管理人的约定，有时候管理人需要先让基金投资者实现某一门槛收益率，之后才可以获得业绩报酬。"
        },
        {
            "title": "股权投资基金通常会直接参与被投资企业股东（大）会、董事会、监事会，其目的是为了降低（　　）。",
            "question": "A. 信用风险\nB. 委托代理风险\nC. 财务风险\nD. 经营风险",
            "answer": "B",
            "explain": "本题考查项目跟踪与监控的内容。为了降低投资后的委托代理风险，投资机构通常会直接参与被投资企业股东大会、董事会和监事会，并以提出议案或参与表决的经营管理实施监控。"
        },
        {
            "title": "关于杠杆收购基金，以下表述错误的是（　　）。",
            "question": "A. 夹层资本具有较大的弹性，通常用来满足特定交易需求\nB. 夹层资本通常是杠杆收购基金为收购提供自有资金的主要方式\nC. 银行贷款可以作为杠杆收购主要的资金来源\nD. 夹层资本通常无法要求融资方提供资产担保",
            "answer": "B",
            "explain": "本题考查杠杆收购资金来源。A选项说法正确，夹层资本弹性较大，融资条款可以根据交易所需进行定制，因而可以满足特定交易的个性化需求。B选项说法错误，杠杆收购基金为收购提供自有资金是股权资本，夹层资本通常由夹层基金、保险公司以及公开市场提供。C选项说法正确，银行贷款是杠杆收购的主要资金来源，是级别最高、成本最低和弹性最低的融资来源。"
        },
        {
            "title": "全国中小企业股份转让系统的性质是（　　）。",
            "question": "A. 社团法人\nB. 会员制\nC. 事业法人\nD. 公司制",
            "answer": "D",
            "explain": "本题考查全国中小企业股份转让系统。全国中小企业股份转让系统简称全国股转系统、NEEQ，俗称“新三板”，是经国务院批准设立的公司制全国性证券交易场所。"
        },
        {
            "title": "以下不属于杠杆收购的收购资金主要来源的是（　　）。",
            "question": "A. 普通股\nB. 夹层资本\nC. 高级债\nD. 高利贷",
            "answer": "D",
            "explain": "本题考查杠杆收购的收购资金来源。杠杆收购的收购资金来源主要包括：（1）普通股，由收购方提供资金。（2）夹层资本，一般采取优先股和垃圾债券的形式，有时附有转股权。"
        },
        {
            "title": "关于公司型股权投资基金，说法错误的是（　　）。",
            "question": "A. 基金可自行或委托专业基金管理人进行基金管理\nB. 基金投资者以以缴的出资为限对基金债务承担有限责任\nC. 基金投资决策委员会由公司股东组成\nD. 基金可采取有限责任公司或股份有限公司的形式",
            "answer": "C",
            "explain": "本题考查公司型基金的内容。A选项说法正确，公司型基金可以由公司管理团队自行管理，或者委托专业的基金机构担任基金管理人。B选项说法正确，公司型股权投资基金采用公司的组织形式，投资者是公司股东，依法享有股东权利，并以其投资额为限对公司债务承担有限责任。C选项说法错误，投资决策委员会一般由基金管理公司的总经理、分管投资的副总经理、投资总监、研究部经理、基金经理等组成。"
        }, {
            "title": "关于股权投资基金管理人在基金运行期间向中国证券投资基金业协会进行的重大事项报告，以下表述正确的是（　　）。",
            "questions": "I. 基金管理人应当在重大事项发生后的5个工作日内向中国证券投资基金业协会报告<br>II. 基金管理人可以在重大事项发生后的20个工作日内向中国证券投资基金业协会报告<br>III. 基金更换托管人，并与新托管人重新签署《托管协议》应当作为重大事项报送<br>IV. 基金实缴规模由5亿元人民币增加至8亿元人民币应当作为重大事项报送",
            "question": "A. II、IV\nB. I、III、IV\nC. I、III\nD. II、III、IV",
            "answer": "B",
            "explain": "本题考查股权投资基金的重大事项。私募基金运行期间，发生以下重大事项的，私募基金管理人应当在5个工作日内向基金业协会报告：基金合同发生重大变化；投资者数量超过法规规定。"
        },
        {
            "title": "使用折现现金流估值法对企业进行估值时，可以直接计算得到股权价值的模型是（　　）。",
            "questions": "I. 红利折现模型<br>II. 股权自由现金流折现模型<br>III. 企业自由现金流折现模型<br>IV. 企业净资产折现模型",
            "question": "A. II、III\nB. II\nC. I、IV\nD. I、II",
            "answer": "D",
            "explain": "本题考查常用的折现模型。"
        },
        {
            "title": "股权投资基金募集过程中，宣传措辞可以包括（　　）。",
            "question": "A. 风控措施完善\nB. 业界最佳、规模最大\nC. 避险、安全\nD. 高收益、无风险",
            "answer": "A",
            "explain": "本题考查从事股权投资基金募集的禁止性行为。（1）股权投资基金募集过程中不得夸大或者片面推介基金，违规使用“安全”“保证”“承诺”“保险”“避险”“有保障”“高收益”“无风险”等进行风险判断的措辞；（C、D选项不符合题意）"
        },
        {
            "title": "假设将投资人分为两种，一种为以IPO为退出方式的长期投资者，另一种为以后续轮次股权溢价转让为退出方式的短期投资者，对于两种按单一拒绝权条款可能在哪种投资者退出时被行使（　　）。",
            "question": "A. 短期投资者\nB. 长期投资者\nC. 短期投资者和长期投资者\nD. 两种投资者退出时都不会被行使",
            "answer": "C",
            "explain": "本题考查第一拒绝权条款。第一拒绝权是指目标公司的其他股东欲对外出售股权时，作为老股东的股权投资基金在同等条件下有优先购买权。无论IPO后的转让退出还是股权溢价转让退出，有股东欲对外出让股权时，第一拒绝权都可能被行使。"
        },
        {
            "title": "某合伙型基金的普通合伙人认缴出资1000万元，有限合伙人合计认缴出资9000万元，全体合伙人于2018年1月1日一次性完成实缴出资，基金计划于2023年1月1日进入清算阶段，可分配金额1亿元。如下，暂不考虑相关债权费用、税费及清算费用，清算阶段普通合伙人及有限合伙人可获得的分配金额为（　　）。",
            "question": "A. 1000万元和9000万元\nB. 2000万元和8000万元\nC. 2280万元和7720万元\nD. 1280万元和8720万元",
            "answer": "D",
            "explain": "本题考查基金收益分配。已知基金于2022年已完成全部合伙人实缴出资的返还，故不用归还投资者的本金。2023年的分配金额1亿元按II、III分配。"
        },
        {
            "title": "投资后管理中，对处于市场扩张阶段的企业，（　　）不能反映出企业的成长速度。",
            "question": "A. 新拓展市场区域\nB. 应收账款金额\nC. 销售增长率\nD. 营业网点开设",
            "answer": "B",
            "explain": "本题考查项目跟踪与监控的经营指标。投资后管理中，依据被投资企业自身经营情况，经营指标监控侧重点也有所不同：（1）对业务和市场已相对成熟稳定的企业：侧重于业绩指标，如收入、净利润、市场占有率等；"
        }, {
            "title": "对于股权投资基金的信息披露，下列做法符合《私募股权投资基金信息披露管理办法》规定的是（　　）。",
            "question": "A. 描述该私募投资基金产品属于高风险产品，可能会因相关风险导致投资者获得不理想收益并损失本金\nB. 在过往历史业绩中隐瞒了大部分亏损的投资项目\nC. 在基金推介材料中附有同业机构的祝贺词\nD. 将该基金信息及认购文件登载至其官网中",
            "answer": "A",
            "explain": "本题考查信息披露的要求。A选项做法符合规定，信息披露的风险揭示原则要求信息披露义务人必须向投资者充分披露基金的所有相关事项，充分揭示风险，使投资者在进行投资决策时充分了解基金产品的风险收益特征，避免由于信息不对称造成投资者对基金产品的风险情况不理性的投资决策，造成投资者利益受损。"
        },
        {
            "title": "股权投资基金监管机构在制定监管规范及实施监管行为时，审慎监管原则应是（　　）。",
            "questions": "I. 注重基金机构的风险防控和偿付能力<br>II. 切实保护投资者的合法权益<br>III. 适应其自身特点的监管原则<br>IV. 确保基金运行稳健和财产安全",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III、IV\nD. I、II、III",
            "answer": "B",
            "explain": "本题考查股权投资基金监管的基本原则中的审慎监管原则。"
        },
        {
            "title": "股权投资基金的信息披露义务人每季度结束、每年度结束后进行信息披露的时间分别为（　　）。",
            "question": "A. 15个工作日以内、4个月以内\nB. 15个工作日以内、3个月以内\nC. 10个工作日以内、4个月以内\nD. 10个工作日以内、3个月以内",
            "answer": "C",
            "explain": "本题考查信息披露的时间。股权投资基金运行期间，股权投资基金的信息披露义务人应当在每季度结束之日起10个工作日内向投资者披露基金投资项目信息。股权投资基金运行期间，股权投资基金信息披露义务人应当在每年度结束之日起4个月内，向投资者披露基金对外投资。"
        },
        {
            "title": "关于项目退出方式，以下表述错误的是（　　）。",
            "questions": "I. 从退出成本的角度来看，相对于首发上市来说，在场外交易市场挂牌所需费用相对较低<br>II. 协议转让的退出风险主要表现为由信息不对称所引起的价格不能充分反映被投资企业实际价值的不确定性<br>III. 从退出效率的角度来看，一般上市转让退出协议转让的方式效率更高<br>IV. 从退出收益的角度来看，一般清算退出的收益较高",
            "question": "A. I、II、III\nB. I、III、IV\nC. II、III、IV\nD. III、IV",
            "answer": "D",
            "explain": "本题考查项目主要退出方式的区别。"
        },
        {
            "title": "股权投资基金清算的常见原因不包括（　　）。",
            "question": "A. 全体合伙人大会决定基金清算\nB. 基金合伙约定的存续期届满\nC. 基金执行事务合伙人决定基金清算\nD. 基金全部投资项目都已清算退出，且按照合伙协议约定不再进行重复投资",
            "answer": "C",
            "explain": "本题考查合伙型基金解散的情形。一般地，合伙型股权投资基金出现以下情形的，应当解散：（1）合伙型股权投资基金存续期届满且合伙人决定不再经营的（B选项）;"
        },
        {
            "title": "合伙型股权投资基金的合伙协议应列明合伙企业终止、解散与清算有关的事项，具体包括（　　）。",
            "question": "A. 注销、解散的条件、清算程序、清算人、清偿及分配、剩余财产处置\nB. 清算程序、清算人及任命条件、剩余财产分配\nC. 终止、解散的条件、清算程序、清算人及任命条件、清偿及分配\nD. 终止与解散的条件、清算人及任命条件、剩余财产分配",
            "answer": "C",
            "explain": "本题考查合伙型基金合同的内容。合伙型股权投资基金的合伙协议应列明合伙企业终止、解散与清算有关的事项，具体包括：终止、解散的条件、清算程序、清算人及任命条件、清偿及分配。"
        }, {
            "title": "关于加权平均资本成本，以下表述错误的是（　　）。",
            "question": "A. 加权平均资本成本是企业各种融资来源的资本成本的加权平均值\nB. 计算不同融资的权重时需考虑各种融资的市场价值\nC. 计算企业加权平均资本成本无需考虑所得税的影响\nD. 企业自由现金流折现模型使用的折现率为加权平均资本成本",
            "answer": "C",
            "explain": "本题考查加权平均资本成本。企业自由现金流对应的折现率为加权平均资本成本（WACC）。加权平均资本成本（WACC）是企业各种融资来源的资本成本的加权平均值，计算公式为：WACC=D/（D+E）×kd×（1-t）+D/（D+E）×ke 其中，D为付息债务的市场价值，E为股权的市场价值，kd为税前债务成本，t为所得税税率。"
        },
        {
            "title": "某美元基金投资境内未上市企业，可以采用的退出方式是（　　）。",
            "questions": "I. 境内企业A股上市后，在A股市场减持退出<br>II. 境内企业在境外间接上市后，在境外资本市场减持退出<br>III. 境内企业通过参与A股上市公司的重大资产重组进而实现间接上市，并在A股市场减持退出<br>IV. 境外公司收购境内企业股权，进而美元基金通过协议转让在境外收款退出",
            "question": "A. I、II、III、IV\nB. II、III、IV\nC. I、II、IV\nD. I、II、III",
            "answer": "A",
            "explain": "本题考查项目退出的主要方式。项目退出的主要方式包括：上市转让退出；在场外交易市场挂牌转让退出；协议转让退出；清算退出。其中上市转让退出包括境内上市（境内首次公开发行）和境外上市（境外首次公开发行）。"
        },
        {
            "title": "关于股权投资基金的出资方式，以下表述错误的是（　　）。",
            "question": "A. 根据基金合同约定，投资者可以一次或分数次完成其在股权投资基金中的出资义务\nB. 在股权投资基金实务运作中，更多的实行承诺出资制\nC. 承诺出资制，即投资者承诺向基金出资的总规模，并按照合同约定完成其出资行为\nD. 股权投资基金通常可以接受非货币出资",
            "answer": "D",
            "explain": "本题考查股权投资基金的出资方式。A选项说法正确，根据基金合同的约定，投资者可以一次或分数次完成其在股权投资基金中的出资义务。B选项说法正确，在股权投资基金实务运作中，更多地实行承诺出资制。C选项说法正确，承诺出资制，即投资者承诺向基金出资的总规模，并按照合同约定完成其出资行为。"
        },
        {
            "title": "《证券投资基金法》中关于基金行业自律组织的表述，以下错误的是（　　）。",
            "question": "A. 《证券投资基金法》明确基金管理人可以加入中国证券投资基金业协会\nB. 《证券投资基金法》为中国证券投资基金业协会的地位和职责提供了基本的法律依据\nC. 《证券投资基金法》明确基金托管人可以加入中国证券投资基金业协会\nD. 《证券投资基金法》明确中国证券投资基金业协会是股权投资行业唯一的自律机构",
            "answer": "D",
            "explain": "本题考查基金行业自律组织。A、C选项说法正确，《证券投资基金法》第一百零九条规定，基金管理人、基金托管人应当加入基金行业协会，基金服务机构可以加入协会。B选项说法正确，2013年6月1日，新修订的《证券投资基金法》增设了第十二章“基金行业协会”，为中国证券投资基金业协会的地位和职责提供了基本的法律依据。"
        },
        {
            "title": "以下分配方式符合合伙型股权投资基金“瀑布式收益分配体系”的是（　　）。",
            "question": "A. 按照约定门槛收益率，先分配门槛收益给所有合伙人，然后返还本金，分配超额收益\nB. 先向有限合伙人返还本金和门槛收益，然后向普通合伙人返还本金，分配超额收益\nC. 按照约定门槛收益率，先分配门槛收益给有限合伙人，再返还本金，然后向普通合伙人返还本金和分配超额收益\nD. 先向所有合伙人返还本金，再按照约定门槛收益率向所有合伙人分配门槛收益，然后分配超额收益",
            "answer": "D",
            "explain": "本题考查基金收益分配与清算。股权投资基金的分配通常采用瀑布式的收益分配体系，具体是，项目投资退出的资金先返还至基金投资者，当投资者收回全部投资本金后，再按照约定的门槛收益率（如有）向基金投资者分配门槛收益。上述步骤完成后，基金管理人才参与基金的收益分配。"
        },
        {
            "title": "某公司在创立时创始人持有20000股股份，股权投资基金X作为A轮投资者以增资方式按2元/股的价格购买了10000股，之后B轮投资者以3元/股的价格购买了10000股。在完全棘轮条款和加权平均条款下X基金分别可获补偿的股票数量为（　　）。",
            "question": "A. 10000股，5000股\nB. 条件不足，无法计算\nC. 5000股，1429股\nD. 10000股，1429股",
            "answer": "D",
            "explain": "本题考查反摊薄条款的保护方式。完全棘轮条款获补偿的股票数量=前轮投资者投入资金÷后轮价格-已有股数=10000×2÷1-10000=10000（股）。加权平均条款A=B×(C+D)/(C+E) 其中，A为前轮投资者经过反稀释补偿调整后的每股新价格；B为前轮投资者在前轮融资时每股价格2元；C为新发行前公司的总股数20000+10000=30000股；D为如果没有降价融资，后轮投资者在后轮投入的全部投资价款原本应获得的股份数量；E为后轮投资者实际获得的股份数量。"
        }, {
            "title": "关于我国二级股票市场的主要交易机制，以下说法正确的是（　　）。",
            "question": "A. 竞价交易的规则约定，ST股票和*ST股票价格的涨跌幅（一个交易日内交易价格相对上一个交易日收市价格）均不得超过20%\nB. 如果收购人自愿选择以要约方式收购上市公司股份，其可以选择向被收购公司的所有股东发出只收购其持有的部分股份的要约\nC. 上市公司股份的买卖双方可以就已达成的转让协议，向证券交易所和登记机构申请办理股份的转让过户，但该股份的转让只限于流通股\nD. 大宗交易转让的买卖双方可以就交易价格和数量进行协商，具有高效率低成本的特点，但会对股票交易价格形成巨大冲击",
            "answer": "B",
            "explain": "本题考查我国证券交易所的主要交易机制。A选项说法错误，无论买入或者卖出，股票在一个交易日内交易价格相对上一个交易日收市价格的涨跌幅不得超过10%，其中ST股票和*ST股票价格涨跌幅不得超过5%（而不是不得超过20%）。B选项说法正确，收购人自愿选择要约方式收购上市公司股份的，可以向被收购公司所有股东发出收购其所持有的全部或部分股份的要约。C选项说法错误，根据转让股份类型的不同，协议转让可以分为流通股协议转让和非流通股协议转让（而不是只限于流通股）。D选项前半句说法正确，后半句说法错误，大宗交易转让的买卖双方可以就交易价格和数量进行协商，具有高效率低成本的特点，但不会对股票交易价格形成巨大冲击。"
        },
        {
            "title": "关于信托（契约）型股权投资基金，以下表述错误的是（　　）。",
            "question": "A. 通常情况下基金份额的转让只涉及出让方、受让方及基金管理人，按照基金合同的约定办理转让手续即可\nB. 除基金合同另有约定外，每份基金份额应具有同等权益\nC. 基金的清算由基金清算小组负责，清算小组由基金管理人、托管人及相关中介服务机构组成\nD. 由基金管理人在市场监督管理部门办理工商登记，基金权益登记事项可由基金管理人自行办理，也可委托持牌的基金服务机构办理",
            "answer": "D",
            "explain": "本题考查信托（契约）型股权投资基金的权益登记。A选项说法正确，一般信托（契约）型股权投资基金份额的转让只涉及出让方、受让方及基金管理人，三方协商同意即可按照基金合同的约定办理转让手续，无须征得其他基金投资者的同意。B选项说法正确，除基金合同另有约定外，信托（契约）型股权投资基金每份基金份额应具有同等的合法权益。"
        },
        {
            "title": "关于股权投资基金的设立，以下表述正确的是（　　）。",
            "questions": "I. 有限合伙企业是非法人企业，无需办理工商注册登记<br>II. 股权投资基金在设立完成前，需先在中国证券投资基金业协会办理基金备案<br>III. 对于不同组织形式的基金，其设立要求不同<br>IV. 信托（契约）型基金以投资者和管理人签署信托契约即为设立，无需办理工商注册登记",
            "question": "A. I、IV\nB. III、IV\nC. II、III、IV\nD. II、III",
            "answer": "B",
            "explain": "本题考查股权投资基金的设立。I项错误，合伙型基金与公司型基金均由工商登记机构进行登记管理。"
        },
        {
            "title": "关于并购基金对实体企业的作用，以下说法错误的是（　　）。",
            "question": "A. 投资早期的科技型企业并助力其重整上市\nB. 联合大型企业设立产业投资基金，帮助实现转型升级\nC. 重新调整管理团队，提升原企业的管理执行效率\nD. 帮助被并购企业与自身其他资源进行整合",
            "answer": "A",
            "explain": "本题考查并购基金对产业转型和升级的贡献。A选项说法错误，创业投资基金通常投资早期的科技型企业，通过帮助企业发展壮大而获利。B选项说法正确，并购基金的运营模式，被很多实体经济中的大企业使用，通过设立和管理并购基金，帮助其实现产业转型和升级。C选项说法正确，收购完成后，并购基金通常会重整被投资企业的管理团队，提升团队的执行力。"
        },
        {
            "title": "关于基金托管费，说法正确的是（　　）。",
            "question": "A. 基金托管费是基金管理人因投资管理基金资产而向基金收取的费用\nB. 基金托管费是基金托管人为基金提供托管服务而向基金收取的费用\nC. 基金托管费是基金托管人因投资管理基金资产而向基金收取的费用\nD. 基金托管费是基金管理人为基金提供托管服务而向基金收取的费用",
            "answer": "B",
            "explain": "本题考查基金托管费的定义。基金管理费是基金管理人因投资管理基金资产而向基金收取的费用（A、C选项说法错误）。"
        },
        {
            "title": "关于折现现金流估值法的折现率，以下表述错误的是（　　）。",
            "question": "A. 股权自由现金流对应的折现率为股权资本成本\nB. 红利对应的折现率为加权平均资本成本\nC. 企业自由现金流对应的折现率为加权平均资本成本\nD. 折现率的选取取决于使用的现金流，二者要对应",
            "answer": "B",
            "explain": "本题考查折现现金流估值法。A选项说法正确，B选项说法错误，红利和股权自由现金流对应的折现率为股权资本成本。"
        }, {
            "title": "股权投资基金应当向合格投资者募集，单只股权投资基金的投资人数累计不得超过（　　）等法律规定的特定数量。",
            "questions": "I. 《证券投资基金法》<br>II. 《公司法》<br>III. 《合伙企业法》",
            "question": "A. II、III\nB. I、III\nC. I、II\nD. I、II、III",
            "answer": "D",
            "explain": "本题考查合格投资者的人数限制。单只股权投资基金的投资者人数累计不得超过《公司法》、《合伙企业法》、《证券投资基金法》等法律规定的特定数量。"
        },
        {
            "title": "股权投资基金投资阶段的环节包括（　　）。",
            "questions": "I. 尽职调查<br>II. 跟踪与监控<br>III. 立项<br>IV. 投资交割",
            "question": "A. I、II、IV\nB. I、II、III\nC. I、III、IV\nD. II、III、IV",
            "answer": "C",
            "explain": "本题考查股权投资基金的运作阶段。"
        },
        {
            "title": "关于投资项目清算退出的表述，以下表述错误的是（　　）。",
            "question": "A. 清算退出一般能够收回大部分或者全部投资\nB. 清算退出包括解散清算和破产清算两种方式\nC. 清算退出时通过被投资企业清算实现退出的行为\nD. 一般来说，清算退出是投资项目失败后的一种退出方式",
            "answer": "A",
            "explain": "本题考查清算退出。A选项说法错误，清算退出一般不能够收回大部分或者全部投资，尤其是通过破产清算方式退出，股东收回全部投资的可能性极小，一般情况下甚至可能损失全部投资。B选项说法正确，清算退出包括解散清算和破产清算两种方式。"
        },
        {
            "title": "下列股权投资基金投资者中，属于合格投资者的是（　　）。",
            "question": "A. 拥有1500万元净资产的A公司为其员工所设立的企业年金\nB. 总资产为1000万元的B公司，现投资200万元于一只股权投资基金\nC. 退休的张先生持有200万元银行存款，最近三年年均收入均为5万元，现将150万元存款投资于一只股权投资基金\nD. 银行职员李先生持有500万元银行理财产品，最近三年年均收入为60万元，现投资50万元于一只股权投资基金",
            "answer": "A",
            "explain": "本题考查合格投资者的标准。合格投资者的标准包括：(1)具备相应风险识别能力和风险承担能力；(2)投资于单只基金的金额不低于100万元；(3)单位合格投资者净资产不低于1000万元；个人合格投资者金融资产不低于300万元或者最近三年年均收入不低于50万元。金融资产包括银行存款、股票、债券、基金份额等。"
        },
        {
            "title": "某股权投资基金的分析员考虑使用市盈率法和企业价值/息税前利润倍数法，对两家同行业公司进行估值，其中公司甲的资本结构由50%股权和50%债权构成，公司乙是由100%股权构成，使用企业价值/息税前利润倍数法时，计算结果显示两家公司的企业价值近乎相等，则下列选项表述正确的是（　　）。",
            "question": "A. 公司甲的股权价值高于公司乙\nB. 适宜更换为市盈率倍数法进行估值\nC. 公司乙的股权价值高于公司甲\nD. 两家公司的股权价值一样",
            "answer": "C",
            "explain": "本题考查企业价值。A、D选项表述错误，C选项表述正确，息税前利润是向所有股东和债权人分配前的利润。企业价值=股权价值+债权价值，当企业价值相等时，公司甲股权价值+公司甲债权价值=公司乙股权价值，所以公司乙的股权价值高于公司甲。"
        },
        {
            "title": "关于大宗交易，以下说法正确的是（　　）。",
            "question": "A. 不会对竞价交易的股票价格形成巨大冲击，有利于市场稳定\nB. 没有规定量任限额\nC. 交易费用相对集中竞价交易要高\nD. 定价由交易双方确定，没有竞价交易灵活",
            "answer": "A",
            "explain": "本题考查大宗交易。A选项说法正确，大宗交易是买卖双方协商交易，不会对竞价交易的股票价格形成巨大冲击，有利于市场稳定。B选项说法错误，大宗交易是指达到规定的最低限额的证券单笔买卖申报，买卖双方经过协议达成一致并经交易所确认成交的证券交易。C选项说法错误，大宗交易转让是通过委托中介机构代为办理，按照交易所规定的大宗交易业务办理流程办理的，其交易经手费比集中竞价交易方式下同品种证券的交易经手费低。"
        }, {
            "title": "关于合伙型股权投资基金清算，以下表述正确的是（　　）。",
            "question": "A. 基金清算退出的资产分配顺序上，应优先向合伙人分配本金\nB. 合伙型股权投资基金解散，应当由基金管理人进行清算\nC. 基金存续期届满应当立即解散并进行清算\nD. 如果全体合伙人一致决定解散，基金可以解散清算",
            "answer": "D",
            "explain": "本题考查合伙型股权投资基金的清算。A项错误，清算退出的资产分配顺序上，合伙型股权投资基金财产在支付清算费用和职工工资、社会保险费用、法定补偿金以及缴纳所欠债务后的剩余财产，向合伙人进行分配。B项错误，合伙型股权投资基金解散，应当由清算人进行清算。C项错误，合伙型股权投资基金存续期届满且合伙人决定不再经营的，应当解散。"
        },
        {
            "title": "下列关于股权投资基金管理人的注册资本的说法正确的是（　　）。",
            "question": "A. 实缴资本不能低于人民币100万元\nB. 认缴资本不低于人民币1000万元\nC. 实缴资本不能低于认缴资本的25%\nD. 实缴资本应当能够满足公司一定期限内的运营",
            "answer": "D",
            "explain": "本题考查对股权投资基金管理人注册资本的要求。股权投资基金管理人应该具有开展股权投资基金管理业务所需的资本金。新设股权投资基金管理人，注册时实缴的注册资本应能覆盖公司一定期间内的合理运营成本；通常，人力、物力、办公、差旅等是应当考虑的成本因素。"
        },
        {
            "title": "不属于投资机构对被投资企业通常采用的跟踪与监控方式的是（　　）。",
            "question": "A. 协助完善被投资企业的公司治理架构\nB. 定期检查协议条款的执行情况\nC. 对被投资企业的财务状况和业绩进行分析\nD. 派驻代表进入被投资企业的董事会",
            "answer": "A",
            "explain": "本题考查项目跟踪与监控的主要方式。项目跟踪与监控的主要方式有：(1)跟踪协议条款执行情况：在投资后管理阶段，投资机构需定期核查协议条款的执行情况，保护自身的合法权益。当发现协议执行中存在重大风险或出现不确定性的情况时，应当立即采取相应的补救措施。(B选项不符合题意)"
        },
        {
            "title": "2017年底，甲公司发行新股进行首轮融资，股权投资基金A按2018年预测净利润的12倍市盈率投后估值2.4亿元对甲公司投资，基金A持股比例分别为90%和10%。2018年甲公司实现净利润1600万元，根据估值调整条款由创始股东对基金A进行了股份补偿。业绩平稳后拟发行新股1500股进行后续融资，基金A按其在甲公司的持股比例行使了优先认购权。新一轮融资后基金A的持股比例为（　　）。",
            "question": "A. 10.8%\nB. 条件不全，无法计算\nC. 12.5%\nD. 10%",
            "answer": "C",
            "explain": "本题考查估值调整条款、优先认购权条款和市盈率估值法。(1)基金投资额：已知持股比例为10%，股权价值为2.4亿元。投资额=股权价值×持股比例=24000×10%=2400（万元）。"
        },
        {
            "title": "股权投资基金使用创业投资估值法时，关于退出时点目标公司股权价值评估，以下表述正确的是（　　）。",
            "question": "A. 以退出时点的可比公司价格为参照，评估目标公司的股权价值\nB. 在退出时，将基金持有目标公司股权期间的现金红利和最终卖出价格，进行折现后加总得出目标公司的相应价值\nC. 在退出时，公司总资产减去总负债后的净值，得出目标公司的相应价值\nD. 将退出时点的公司现金流以合适的折现率折现后加总，得出目标公司的股权价值",
            "answer": "A",
            "explain": "本题考查创业投资估值法。A选项符合题意，股权投资基金预测投资退出的时点，然后估算该时点目标公司的股权价值，估值方法一般使用相对估值法。相对估值法的基础是以可比公司的价格为基础，来评估目标公司的相应价值。"
        },
        {
            "title": "某股权投资基金拟投资的目标公司处于创业早期，和国和国金流为负，未来回报可能较高，对其估值一般采用的估值方法是（　　）。",
            "question": "A. 相对估值法\nB. 清算价值法\nC. 创业投资估值法\nD. 重置成本法",
            "answer": "C",
            "explain": "本题考查创业投资估值法的适用范围。A选项不符合题意，相对估值法的基本原理是以可比公司的价格为基础，来评估目标公司的相应价值。评估所得的价值，可以是股权价值，也可以是企业价值。使用可比价值对目标公司进行价值评估，在创业投资基金和并购基金中大量使用。B选项不符合题意，清算价值法常见于杠杆收购和破产投资策略。一般采用清算价值法估值时采用较低的折扣率。对于股权投资机构而言，清算很难获得很好的投资回报，在企业正常可持续经营的情况下，不会采用清算价值法。"
        }, {
            "title": "估值调整条款潜在触发条件不包括（　　）。",
            "question": "A. 企业未能在约定时间前实现IPO上市\nB. 企业高管发生严重违反约定的事件\nC. 企业在根据估值条款约定的业绩考核截止日归母净利润达到了业绩承诺，但拒绝对未来三年的业绩进行新的业绩承诺\nD. 企业原大股东失去控股地位",
            "answer": "C",
            "explain": "本题考查估值调整机制的触发条件。估值调整机制的触发条件：（1）目标公司的实际业绩未达到事先约定的业绩目标；（2）发生特定事件，如公司未在约定时间前实现IPO（A选项）、原大股东失去控股地位（D选项）、高管严重违反约定（B选项）等。"
        },
        {
            "title": "基金服务机构中的份额登记服务内容不包括（　　）。",
            "question": "A. 需妥善保管登记数据，保存期限自基金账户销户之日起不得少于20年\nB. 基金份额登记机构应当保证登记数据的真实、准确、完整\nC. 定期开展基金会计核算、报表编制等工作\nD. 基金份额持有人的名称、身份信息及基金份额明细等数据备份至中国证监会认定的机构",
            "answer": "C",
            "explain": "本题考查份额登记服务内容。份额登记服务，是指基金服务机构代理基金管理人为股权投资基金办理基金份额登记过户、存管、结算等活动。基本职责包括：建立并管理投资者的基金账户、负责基金份额的登记及资金结算、基金交易确认、代理发放红利、保管投资者名册、法律法规或服务协议规定的其他职责。"
        },
        {
            "title": "从投资后管理角度，以下属于股权投资基金需要关注的风险的是（　　）。",
            "questions": "I. 被投资企业新技术开发的技术风险<br>II. 企业家管理团队的尽责风险与道德风险<br>III. 在管多只基金投资同一企业的利益冲突风险<br>IV. 未能谨慎选择估值方法对被投企业公允价值进行合理计量的风险",
            "question": "A. I、II\nB. I、II、IV\nC. I、II、III、IV\nD. III、IV",
            "answer": "A",
            "explain": "本题考查投资后管理的作用。"
        },
        {
            "title": "股权投资基金管理人在向中国证券投资基金业协会申请管理人登记时，必须具有基金从业资格的人员包括（　　）。",
            "questions": "I. 法定代表人/执行事务合伙人委派代表<br>II. 行政主管<br>III. 总经理<br>IV. 合规风控负责人",
            "question": "A. I、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、II、III、IV",
            "answer": "A",
            "explain": "本题考查高级管理人员的内容。管理人在向基金业协会申请管理人登记时，要审核申请机构的高管人员是否具备基金从业资格，高管岗位设置是否符合中国证券投资基金业协会的"
        },
        {
            "title": "关于股权投资基金投资者披露信息，以下表述错误的是（　　）。",
            "question": "A. 信息披露指引由中国证监会制定，中国证券投资基金业协会依据指引进行信息披露行业自律管理\nB. 股权投资基金的管理人和托管人均应按照规定进行信息披露\nC. 基金合同应当明确信息披露义务人向投资者进行信息披露的内容、披露频度、披露方式、披露责任以及披露渠道\nD. 股权投资基金的信息披露义务人应当在基金合同中约定向投资者披露可能存在的利益冲突情况以及可能影响投资者合法权益的其他重大信息",
            "answer": "A",
            "explain": "本题考查信息披露的监管。A选项说法错误，信息披露指引由中国证券投资基金业协会制定。B选项说法正确，股权投资基金的管理人和托管人均应按照规定进行信息披露。C选项说法正确，股权投资基金的基金合同应当包含信息披露的具体安排，包括信息披露义务人向投资者进行信息披露的内容、披露频度、披露方式、披露责任以及信息披露渠道等事项。"
        },
        {
            "title": "某股权投资基金于2011年成立，截至2014年底，投资者缴款总金额为8亿元，基金资产净值10亿元，已分配收益倍数为0.75，2011年至2013年期间投资者合计获得2亿元现金分红，则2014年投资者从该基金获得的分配金额为（　　）。",
            "question": "A. 5.5亿元\nB. 4.0亿元\nC. 0.4亿元\nD. 7.5亿元",
            "answer": "B",
            "explain": "本题考查已分配收益倍数的计算。已分配收益倍数=算公式为DPI=（DO+D1+D0+…+Dn）/（PIO+PI1+PIO+…+Pin）。已知已分配倍数DPI为0.75，投资者历年向基金支付的实缴出资额PI为8亿元。投资者历年从基金获得的分配额D=0.75×8=6（亿元）。已知2011-2013年获得2亿元，则2014年获得6-2=4（亿元）。"
        }, {
            "title": "投资基金的退出方式呈现多样化的特点，关于股权投资基金退出方式，以下表达错误的是（　　）。",
            "question": "A. 上市转让退出的收益一般要比挂牌转让退出的收益高\nB. 上市转让退出的时间一般要比挂牌转让退出的时间长\nC. 上市转让退出的收益一般要比协议转让退出的收益高\nD. 上市转让退出的时间一般要比协议转让退出的时间短",
            "answer": "D",
            "explain": "本题考查项目退出的主要方式。D项错误，上市转让退出的时间一般要比协议转让退出的时间长。从退出效率的角度来看，如果选择上市的话，从券商进场确定股改基准日算起，完成首次公开发行股票并上市（以下简称首发上市）一般需要2年甚至更长时间，上市成功后一般还有相当期限的限售期，实现最终退出耗时较长。对协议转让而言，收购方和被收购方谈定交易价格和条件后，就可以进行交割，并且交易后不存在限售期的问题，股权投资基金通过协议转让退出的方式"
        },
        {
            "title": "关于并购基金的表述正确的是（　　）。",
            "question": "A. 并购基金往往通过注资的形式对企业增量股权进行投资\nB. 并购基金投资对象主要是成长期企业\nC. 并购基金的收益主要来源于因管理增值带来的股权增值\nD. 并购基金因规模较大，往往以自有资金进行并购",
            "answer": "C",
            "explain": "本题考查并购基金的特点。并购基金是指主要对企业进行财务性并购投资的股权投资基金，通过购买股权的形式对企业的存量股权进行投资。(A选项“增量股权”表述错误) 并购基金在收购中通常采取较高的杠杆率，因此，并购基金主要是杠杆收购基金，杠杆收购基金的特点包括：（1）从投资对象看，主要是成熟企业；(B选项中“成长期企业”表述错误)"
        },
        {
            "title": "合格投资者A拟受让投资者B持有的某股权投资基金份额，其可以受让的最低基金份额金额为（　　）。",
            "question": "A. 100万元\nB. 50万元\nC. 60万元\nD. 30万元",
            "answer": "A",
            "explain": "本题考查合格投资者。股权投资基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只基金的金额不低于100万元且符合相关标准的单位和个人。故可以受让的最低基金份额金额为100万元。"
        },
        {
            "title": "股权投资基金募集期间，信息披露义务人应当在宣传推介材料中向投资者披露的信息不包括（　　）。",
            "question": "A. 基金合同的主要条款\nB. 基金的投资信息\nC. 基金的申购与赎回安排\nD. 基金财务会计报告",
            "answer": "D",
            "explain": "本题考查信息披露的主要事项。基金募集期间，应当在宣传推介材料中向投资者披露如下信息：基金基本信息；管理人基本信息；基金的投资信息；基金的募集期限；基金估值政策、程序和定价模式；基金合同的主要条款；基金的申购与赎回安排；基金管理人最近三年的诚信情况说明；其他事项。"
        },
        {
            "title": "（　　）是指在现时条件下重新购置一项全新状态的资产所需的全部成本。",
            "question": "A. 完全重置成本\nB. 重置成本\nC. 历史成本\nD. 公允成本",
            "answer": "A",
            "explain": "本题考查重置成本法。A项正确，完全重置成本是指在现时条件下重新购置一项全新状态的资产所需的全部成本。"
        },
        {
            "title": "目前，我国要求包括股权投资基金在内的各类私募基金的募集需履行的程序不包括（　　）。",
            "question": "A. 不特定对象确定\nB. 投资者适当性匹配\nC. 基金风险揭示\nD. 合格投资者确认",
            "answer": "A",
            "explain": "本题考查股权投资基金募集流程。目前，我国要求包括股权投资基金在内的各类私募基金的募集需履行的程序包括：特定对象确定、投资者适当性匹配、基金风险揭示、合格投资者确认、投资冷静期以及回访确认（非强制）等步骤。"
        }, {
            "title": "下列构成非法吸收公众存款罪的是（　　）。",
            "questions": "I. 不具有房产销售的真实内容或者不以房产销售为主要目的，以返本销售方式非法吸收资金的<br>II. 以转让林权并代为管护等方式非法吸收资金的<br>III. 不具有发行股票、债券的真实内容，以虚假转让股权、发售虚构债券等方式非法吸收资金的<br>IV. 以委托理财的方式非法吸收资金的",
            "question": "A. I、II、III\nB. I、II、IV\nC. II、III、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查非法吸收公众存款罪。实施下列任一行为均可构成非法吸收公众存款罪："
        },
        {
            "title": "基金管理人在中国证券投资基金业协会申请登记的，通常应提交的材料或信息包括（　　）。",
            "questions": "I. 公司章程或者合伙协议<br>II. 基金委托管理协议<br>III. 基金管理人基本制度<br>IV. 法律意见书",
            "question": "A. I、II\nB. I、II、III\nC. I、III、IV\nD. I、II、III、IV",
            "answer": "C",
            "explain": "本题考查登记与备案的内容。基金管理人申请基金管理人登记的，通常应提交以下材料或信息："
        },
        {
            "title": "（　　）原则要求基金使用规范的语言及形式进行信息披露，避免由于内容或表达方式的不当而造成误解。",
            "question": "A. 规范性\nB. 准确性\nC. 完整性\nD. 易解性",
            "answer": "B",
            "explain": "本题考查披露内容上应遵循的原则。准确性原则要求基金使用规范的语言及形式进行信息披露，避免由于内容或表达方式的不当而造成误解。"
        },
        {
            "title": "合伙型基金是指投资者依据合伙企业法成立有限合伙企业，由（　　）合伙债务承担无限连带责任，由基金管理人具体负责投资运作的股权投资基金。",
            "question": "A. 普通合伙人\nB. 有限合伙人\nC. 基金管理人\nD. 基金托管人",
            "answer": "A",
            "explain": "本题考查合伙型基金的概念。合伙型股权投资基金采用有限合伙企业的组织形式，投资者作为合伙人参与投资，依法享有合伙企业财产权，由普通合伙人对合伙债务承担无限连带责任，由基金管理人具体负责投资运作。合伙型基金不具有独立的法人地位。"
        },
        {
            "title": "相对估值法的优点有（　　）。",
            "question": "A. 运用简单，易于理解\nB. 主观因素相对较少\nC. 可以及时反映市场看法的变化\nD. 以上都对",
            "answer": "D",
            "explain": "本题考查相对估值法的优点和不足。相对估值法具有以下优点：（1）运用简单，易于理解。（2）主观因素相对较少。（3）可以及时反映市场看法的变化。"
        },
        {
            "title": "有限责任公司股东向股东以外的人转让股权，应当经其他股东（　　）同意。",
            "question": "A. 至少1/3\nB. 至少2/3\nC. 过半数\nD. 全部",
            "answer": "C",
            "explain": "本题考查并购退出。有限责任公司股东向股东以外的人转让股权，应当经其他股东过半数同意。"
        }, {
            "title": "目前具有基金销售业务资格的主体包括（　　）等。",
            "question": "A. 商业银行、证券公司、期货公司\nB. 保险机构、证券投资咨询机构\nC. 独立基金销售机构\nD. 以上都是",
            "answer": "D",
            "explain": "本题考查基金销售机构。目前具有基金销售业务资格的主体包括商业银行、证券公司、期货公司、保险机构、证券投资咨询机构、独立基金销售机构等。"
        },
        {
            "title": "有限合伙企业由（　　）个以上50个以下合伙人设立。",
            "question": "A. 1\nB. 2\nC. 5\nD. 10",
            "answer": "B",
            "explain": "本题考查合伙型基金的设立。B选项符合题意，有限合伙企业由2个以上50个以下合伙人设立，但是法律法规另有规定的除外，有限合伙企业至少应当有一个普通合伙人。"
        },
        {
            "title": "股权投资基金项目的主要来源有（　　）。",
            "questions": "I. 行业展会、创业计划大赛、创投论坛等<br>II. 企业家联盟及各级商会组织推荐<br>III. 行业研究:跟踪和研究国内外新技术的发展趋势以及资本市场的动态，通过资料调研、项目库推荐、访问企业等方式寻找项目信息<br>IV. 中介机构推荐:包括律师、会计师、证券公司、商业银行、财务顾问等",
            "question": "A. I、II、III\nB. II、III、IV\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查项目开发与筛选。股权投资基金项目来源主要包括以下几项："
        },
        {
            "title": "下列选项中属于场外市场的是（　　）。",
            "question": "A. 主板市场\nB. 科创板市场\nC. 创业板市场\nD. 区域性股权交易市场",
            "answer": "D",
            "explain": "本题考查挂牌转让退出概述。我国场外市场包括全国性股权交易市场与区域性股权交易市场。其他三项属于场内市场。"
        },
        {
            "title": "（　　）是指外国投资者(外国投资者指外国公司、企业和其他经济组织或者个人)或外国投资者与根据中国法律注册成立的公司、企业或其他经济组织依据中国法律在中国境内发起设立的主要以人民币对中国境内非公开交易股权进行投资的股权投资基金。",
            "question": "A. 内资人民币股权投资基金\nB. 外资人民币股权投资基金\nC. 股权投资母基金\nD. 政府引导基金",
            "answer": "B",
            "explain": "本题考查人民币基金。外资人民币股权投资基金，是指外国投资者(外国投资者指外国公司、企业和其他经济组织或者个人)或外国投资者与根据中国法律注册成立的公司、企业或其他经济组织依据中国法律在中国境内发起设立的主要以人民币对中国境内非公开交易股权进行投资的股权投资基金。"
        },
        {
            "title": "下列关于外币股权投资基金基本运作方式的说法中，错误的是（　　）。",
            "question": "A. 外币股权投资基金可以在国内以基金名义注册法人实体\nB. 外币股权投资基金经营实体注册在境外\nC. 外币股权投资基金在投资过程中，通常在境外设立特殊目的公司作为受资对象\nD. 外币股权投资基金在境外完成项目的投资退出",
            "answer": "A",
            "explain": "本题考查外币基金。外币股权投资基金，是指依据中国境外的相关法律在中国境外设立，主要以外币对中国境内的企业进行投资的股权投资基金。外币股权投资基金通常采取“两头在外”的方式。"
        },
        {
            "title": "关于尽职调查的作用，下列说法错误的是（　　）。",
            "question": "A. 帮助投资方判断目标公司是否值得投资并获取项目估值所需信息\nB. 通过获取目标公司的真实信息，识别和评估目标公司的主要风险，降低信息不对称可能带来的问题\nC. 项目投资决策需要收集充分的信息，全面识别投资风险，评估风险大小并提出风险应对的方案\nD. 帮助投资方在投资决策谈判、投资后管理重点内容、项目退出方式选择等方面的决策提供依据",
            "answer": "C",
            "explain": "本题考查风险发现。C选项错误，基金管理人需要收集充分的信息，全面识别投资风险、评估风险大小并提出风险应对的方案。"
        },
        {
            "title": "对行政处罚不服的，可在收到处罚决定书之日起（　　）日内申请行政复议。",
            "question": "A. 60\nB. 30\nC. 14\nD. 7",
            "answer": "A",
            "explain": "本题考查股权投资基金管理人、托管人及相关服务机构违反法律法规的行政处罚。对行政处罚不服的，可在收到处罚决定书之日起60日内申请行政复议，也可以在收到处罚决定书之日起3个月内直接向有管辖权的人民法院提起行政诉讼。"
        },
        {
            "title": "投资协议与投资备忘录的主要条款包括（　　）。",
            "questions": "I. 估值条款\nII. 回售权条款\nIII. 反摊薄条款\nIV. 保护性条款",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查投资协议与投资备忘录的主要条款。"
        },
        {
            "title": "股权投资基金管理人、托管人、销售机构及其他服务机构及其从业人员从事股权投资基金业务，属于禁止性行为的是（　　）。",
            "question": "A. 公平地对待其管理的不同基金财产\nB. 不从事内幕交易\nC. 侵占、挪用基金财产\nD. 按照规定履行职责",
            "answer": "C",
            "explain": "本题考查投资运作中的禁止行为。C选项符合题意，股权投资基金管理人、股权投资基金托管人、股权投资基金销售机构及其他市场服务机构及其从业人员从事股权不得有以下行为："
        },
        {
            "title": "投资者应当以书面方式承诺其为自己购买基金，任何机构和个人不得以（　　）为目的购买基金。",
            "question": "A. 非法拆分转让\nB. 规避风险\nC. 转让\nD. 盈利",
            "answer": "A",
            "explain": "本题考查明确合格投资者标准。投资者应当以书面方式承诺其为自己购买私募基金，任何机构和个人不得以非法拆分转让为目的购买私募基金。"
        },
        {
            "title": "某股权投资基金拟投资A公司，假设A公司的管理层承诺投资当年的净利润为9000万元，按照息税前利润的8倍进行估值，A公司的价值为12亿元。企业所得税税率为25%，则A公司每年所需支付债权人的利息为（　　）万元。",
            "question": "A. 2000\nB. 2250\nC. 1000\nD. 3000",
            "answer": "D",
            "explain": "本题考查企业价值/息税前利润倍数法。(1)息税前利润已知企业价值为12亿元，(EV/EBIT倍数)为8倍。息税前利润=企业价值÷(EV/EBIT倍数)=12÷8=1.5(亿元)。(2)总利润已知净利润为9000万元，所得税税率为25%。总利润=净利润÷(1-所得税率)=9000÷(1-25%)=12000(万元)。"
        }, {
            "title": "下列关于公司型股权投资基金的说法中，错误的是（　　）。",
            "question": "A. 可采取有限责任公司或股份有限公司两种形式\nB. 采用公司的组织形式，投资者是公司股东\nC. 参与主体主要为投资者和基金管理人\nD. 只能由公司法人实体自行进行管理",
            "answer": "D",
            "explain": "本题考查公司型基金的概念。A选项正确，在我国，公司型基金可采取有限责任公司或股份有限公司的形式。B选项正确，公司型股权投资基金采用公司的组织形式，投资者是公司股东，依法享有股东权利，并以其投资额为限对公司债务承担有限责任。"
        },
        {
            "title": "甲以设立合伙企业(非经备案的投资计划)的形式汇集多数投资者的资金，直接或间接投资于乙管理的股权投资基金，下列有关核查合格投资者的表述中，正确的是（　　）。",
            "question": "A. 如直接投资于乙管理的基金，基金管理人应当穿透核查最终投资者是否为合格投资者\nB. 如间接投资于乙管理的基金，基金托管人应当穿透核查最终投资者是否为合格投资者\nC. 如间接投资于乙管理的基金，中国证监会应当穿透核查最终投资者是否为合格投资者\nD. 如间接投资于乙管理的基金，基金份额登记机构应当穿透核查最终投资者是否为合格投资者",
            "answer": "A",
            "explain": "本题考查合格投资者。以合伙企业、契约等非法人形式，通过汇集多数投资者的资金直接或者间接投资于股权投资基金的，股权投资基金管理人或者股权投资基金销售机构应当穿透核查最终投资者是否为合格投资者，并合并计算投资者人数。"
        },
        {
            "title": "信息披露义务人包括（　　）。",
            "questions": "I. 股权投资基金管理人<br>II. 股权投资基金托管人<br>III. 法律、行政法规、中国证监会和中国基金业协会规定的负有信息披露义务的法人<br>IV. 法律、行政法规、中国证监会和中国基金业协会规定的负有信息披露义务的其他组织",
            "question": "A. I、II、III\nB. II、III、IV\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查募集的概念。信息披露义务人，是指股权投资基金管理人，股权投资基金托管人，以及法律、行政法规、中国证监会和中国基金业协会规定的负有信息披露义务的法人和其他组织。"
        },
        {
            "title": "关于业务尽职调查的内容，以下表述错误的是（　　）。",
            "question": "A. 调查企业基本情况，包括企业工商登记资料和历史沿革\nB. 调查企业的风险状况，包括政策、竞争、财务及管理等方面\nC. 调查企业的发展战略，包括企业经营理念和模式\nD. 调查企业财务业绩情况，包括历史业绩和未来财务状况预测",
            "answer": "D",
            "explain": "本题考查投资调查与分析业务尽职调查的主要内容包括企业基本情况、管理团队、产品服务、市场、发展战略、融资运用、风险分析。调查企业财务业绩情况属于财务尽职调查。"
        },
        {
            "title": "股权投资基金募集资料中，基金条款书常见的内容有（　　）。",
            "questions": "I. 投资范围条款<br>II. 利润分配条款<br>III. 缴款安排条款<br>IV. 保密条款",
            "question": "A. I、II、III\nB. II、III\nC. I、II\nD. I、II、III、IV",
            "answer": "A",
            "explain": "本题考查股权投资基金的募集与设立。"
        },
        {
            "title": "基金管理人应通过授权控制来控制业务活动的运作，授权控制应当贯穿于管理人经营活动的始终，下列关于授权控制主要内容的表述错误的是（　　）。",
            "question": "A. 对已获授权的部门和人员应建立有效的评价和反馈机制\nB. 所有业务的授权应当采取书面形式，授权书应当明确授权内容和时效\nC. 股东会、董事会、监事会和管理层应当充分了解和履行各自的职权，建立健全公司授权标准和程序\nD. 授权要适当，对于已经不适用的授权应当及时修改或者取消",
            "answer": "B",
            "explain": "本题考查管理人内部控制的要素构成。重大业务的授权应当采取书面形式。授权书应当明确授权内容和时效。"
        }, {
            "title": "基金在不同时点进行业绩评价可能会得到非常不同的结果，为此，股权投资基金的业绩评价原则上应以（　　）为前提。",
            "questions": "I. 基金设立的时间应尽量接近<br>II. 业绩评价的时间应尽量统一<br>III. 金额相近<br>IV. 股东持股比例相近",
            "question": "A. I、II\nB. II、III、IV\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "A",
            "explain": "本题考查基金业绩评价需考虑的因素。"
        },
        {
            "title": "(材料题)某股权投资基金的基金合同约定：按照单一项目的收益分配方式，对于来自投资项目的可供分配现金，分配顺序为：(1)按出资合伙人的实缴出资比例返还投资本金；(2)按单利每年8%向出资合伙人分配门槛收益；(3)按单利每年2%向管理人分配追加；(4)按出资合伙人80%，管理人20%的比例进行分配。暂不考虑管理费等基金费用，退出金额即为可分配金额。(1)该基金第1个投资项目在第2年年底退出，投资金额为2亿元，投资年限(即投资人出资基金投资项目至项目退出的时间为2年)，退出金额为2.36亿元，退出时立即分配。出资合伙人和管理人各分配到（　　）。",
            "question": "A. 2亿元、2亿元\nB. 3.2亿元、0.8亿元\nC. 3.6亿元、0.4亿元\nD. 4亿元、0元",
            "answer": "C",
            "explain": "本题考查基金收益分配与清算。"
        },
        {
            "title": "(材料题)某股权投资基金的基金合同约定：按照单一项目的收益分配方式，对于来自投资项目的可供分配现金，分配顺序为：(1)按出资合伙人的实缴出资比例返还投资本金；(2)按单利每年8%向出资合伙人分配门槛收益；(3)按单利每年2%向管理人分配追加；(4)按出资合伙人80%，管理人20%的比例进行分配。暂不考虑管理费等基金费用，退出金额即为可分配金额。(2)该基金第2个投资项目在第4年年底退出，投资金额为2亿元，投资期限(即投资人出资基金投资项目至项目退出的时间为4年)，退出金额为2.36亿元。退出时立即分配。出资合伙人和管理人各分配到（　　）。",
            "question": "A. 2.288亿元、0.072亿元\nB. 2.32亿元、0.04亿元\nC. 2.36亿元、0元\nD. 2亿元、0.36亿元",
            "answer": "B",
            "explain": "本题考查基金收益分配与清算。"
        },
        {
            "title": "(材料题)某股权投资基金的基金合同约定：按照单一项目的收益分配方式，对于来自投资项目的可供分配现金，分配顺序为：(1)按出资合伙人的实缴出资比例返还投资本金；(2)按单利每年8%向出资合伙人分配门槛收益；(3)按单利每年2%向管理人分配追加；(4)按出资合伙人80%，管理人20%的比例进行分配。暂不考虑管理费等基金费用，退出金额即为可分配金额。(3)该基金第3个投资项目在第5年年底退出。投资金额为2亿元，投资期限(即投资人出资基金投资项目至项目退出的时间)为5年，退出金额为2.3亿元，退出时立即分配。出资合伙人和管理人各分配到（　　）。",
            "question": "A. 2.24亿元、0.06亿元\nB. 2.06亿元、0.24亿元\nC. 2亿元、0.3亿元\nD. 2.3亿元、0元",
            "answer": "D",
            "explain": "本题考查基金收益分配与清算。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/smgq-6.js